import React from 'react'
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from 'sonner'
import { ThemeProvider } from '@/components/theme/theme-provider';
import { LanguageProvider } from './language-provider';
import { queryClient } from '@/config/query'
import { env } from '@/config/env'

interface Props {
    children: React.ReactNode;
}

const Providers = ({ children }: Props) => {
    // HelmetProvider lives in main.tsx (client) and entry-server.tsx (prerender, with
    // the collecting context); a second one here would shadow it and leave the SSR head empty.
    return (
            <QueryClientProvider client={queryClient}>
                <LanguageProvider>
                    <ThemeProvider
                        attribute="class"
                        defaultTheme="dark"
                        enableSystem
                        disableTransitionOnChange
                    >
                        {children}
                        <Toaster position="top-right" />
                        {env.isDevelopment && <ReactQueryDevtools initialIsOpen={false} />}
                    </ThemeProvider>
                </LanguageProvider>
            </QueryClientProvider>
    )
};

export { Providers }
